import * as tslib_1 from "tslib";
import styled from '../styles';
import { getColorFromTheme } from '../utils/colors';
/**
 * @ReactComponent
 *
 * 文本组件
 */
var Text = styled.div.attrs({
    type: function (props) { return props.type || 'body1'; },
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n  line-height: ", "rem;\n  font-size: ", "rem;\n  font-weight: ", ";\n  font-family: ", ";\n  margin-bottom: ", "px;\n  letter-spacing: ", ";\n  margin-top: ", ";\n"], ["\n  color: ",
    ";\n  line-height: ", "rem;\n  font-size: ", "rem;\n  font-weight: ", ";\n  font-family: ", ";\n  margin-bottom: ",
    "px;\n  letter-spacing: ",
    ";\n  margin-top: ",
    ";\n"])), function (props) {
    return getColorFromTheme(props, props.theme.typography[props.type].color ||
        props.theme.palette.primary[500]);
}, function (props) { return props.theme.typography[props.type].lineHeight; }, function (props) { return props.theme.typography[props.type].fontSize; }, function (props) { return props.theme.typography[props.type].fontWeight; }, function (props) { return props.theme.typography[props.type].fontFamily; }, function (props) {
    return props.gutterBottom
        ? props.theme.typography[props.type].fontSize * 16 * 0.35
        : props.paragraph
            ? 16
            : 0;
}, function (props) {
    return props.theme.typography[props.type].letterSpacing;
}, function (props) {
    return typeof props.leading === 'number' ? props.leading + "rem" : props.leading;
});
Text.displayName = 'Typography';
Text.sinouiName = 'Typography';
export default Text;
var templateObject_1;
//# sourceMappingURL=Typography.js.map